import { Fragment, useState, useCallback } from "react";

import { useMyNichesQuery } from "queries";
import { NicheBrowser } from "components/niches/NicheBrowser";
import { ComboHeader } from "components/blocks/ComboHeader";
import { FeedControl } from "components/feed/FeedControl";
import { routes } from "routes";
import { BaseButton } from "components/buttons/BaseButton";
import { CreateNichePopup } from "components/niches/CreateNichePopup";
import { useVisitorInfo } from "hooks";

import "../ExploreNichesPage/ExploreNichesPage.scss";
import { FooterAds } from "../../components/ads/FooterAds";

export const MyNichesPage = () => {
  const [showCreateNiche, setShowCreateNiche] = useState<boolean>(false);
  const [tiles, setTiles] = useState<boolean>(true);
  const currentUser = useVisitorInfo();
  const { data } = useMyNichesQuery({
    previews: !tiles
  });
  const niches = data && data.niches;

  const changeMode = (mode: boolean) => {
    setTiles(mode);
  };

  const toggleShowCreateNiche = useCallback(() => {
    setShowCreateNiche(prev => !prev);
  }, []);

  return (
    <Fragment>
      <div className="wide page nichesPage">
        <div className="nicheTopNav myNicheTopNav">
          <ComboHeader
            back={routes.niches()}
            text="My Niches"
          />
          {currentUser?.isContentManager() && <div className="nicheCreateBtn">
            <BaseButton onClick={toggleShowCreateNiche}>Create Niche</BaseButton>
          </div>}
        </div>

        <FeedControl
          order=""
          tiles={tiles}
          changeOrder={() => {}}
          changeMode={changeMode}
        />

        <NicheBrowser
          myNiche
          myWithPreview={!tiles}
          niches={niches || []}
        />

        {showCreateNiche && (
          <CreateNichePopup
            isOpen={showCreateNiche}
            onClose={toggleShowCreateNiche}
          />
        )}
      </div>

      <FooterAds/>
    </Fragment>
  );
};
